import { MAILTO_EMAIL } from '@/utils/constants';
import Link from 'next/link';
import { useErrorMessageProvider } from '../Provider/ErrorMessageProvider';

export default function ErrorMessage({ error = false }: { error: any }) {
  if (!error) return <></>;

  return (
    <div className="fixed top-0 z-50 w-screen mx-auto">
      <div className="px-1.6 font-medium flex justify-center items-center text-white bg-red-500 text-body w-screen h-20">
        {typeof error === 'string' ? (
          <>
            <span className="capitalize mr-0.3">{error.split(' ')[0]}</span>{' '}
            <span>{error.split(' ').slice(1).join(' ')}</span>
          </>
        ) : (
          <span>
            We ran into an error processing your request, please try again. If
            the issue persists, please contact{' '}
            <Link href={MAILTO_EMAIL}>hello@olea.art</Link>
          </span>
        )}
      </div>
    </div>
  );
}

export function ErrorMessageWithProvider() {
  const { errorMessage } = useErrorMessageProvider();

  return <ErrorMessage error={errorMessage} />;
}
